<template>
    <div class="common_container">

        <el-form :model="ruleForm" ref="ruleForm" :rules='rules' v-loading='loading' label-width="90px">

            <!-- 上级目录 当前名称 -->
            <el-row>
                <el-col :span="24">
                    <!-- v-if='!ruleForm.parentId[0].indexOf("group") && typeflag !== "edit" ' -->
                    <el-form-item label="上级目录">
                        <el-cascader
                            class="form-input"
                            :props="parentId"
                            disabled
                            v-model="ruleForm.parentId"
                            :show-all-levels='false'
                            @change="showSelect"
                        >
                            <template slot-scope="{ node, data }">
                                <span>{{ data.label }}</span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="当前名称" prop='name'>
                        <el-input v-model="ruleForm.name" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 描述 权限 -->
            <el-row>
                <el-col :span="24" >
                    <el-form-item label="描述" v-if='typeof(ruleForm.parentId[0]) ==="string" && ruleForm.parentId[0].split("_")[1] === "group"'>
                        <el-input v-model="ruleForm.description" class="form-input"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24" >
                    <el-form-item label="权限" v-if='typeof(ruleForm.parentId[0]) ==="string" && ruleForm.parentId[0].split("_")[1] === "department" || "custom_department"'>
                        <el-input v-model="ruleForm.order" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ type == 'edit' ? '修改' : '创建' }}</el-button>
                        <el-button type="default" size="small" @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
    </div>
</template>

<script>

    import { getRules } from './system.rules'

    import services from './system.services'

    const rules = getRules();

    export default {

        props: {
            type: {
                type: String,
                default: 'add'
            },
            row: Object,
            groupName:String,
            callback: Function
        },

        data() {
            return {
                ruleForm: {
                    parentId: [],
                },
                rules,
                rowtype:'custom_department',
                loading: true,
                parentId: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        if (node.root) {
                            services.treeTop().then(res => {
                                const nodes = Array.from(res.list.map(item => {
                                    if (item.type ==='group') {
                                        return {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: true
                                        }
                                    }
                                    else {
                                        return {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: !item.children
                                        }
                                    }
                                }))
                                resolve(nodes);
                            })
                        } else {
                            let { value } = node
                            services.treeChildren({ departmentId:value.split('_')[0], type: value.split('_')[1] }).then(res => {
                                const nodes = Array.from(res.list.map(item => {
                                        return  {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: !item.children
                                        }
                                    }
                                ))
                                resolve(nodes);
                            })
                        }
                    }
                }
            }
        },

        created() {
            // console.log(this.callback);
            console.log(this.row)
            if (this.type === 'edit') {
                this.$modal.title = '编辑'
                this.ruleForm = {
                    parentId: ['99998_group'],
                    // parentId: this.row.parentId ? [this.row.parentId+"_"+this.row.type] : ["0"],
                    name: this.row.group_name,
                    order: this.row.order,
                    description: this.row.description,
                    id: this.row.group_id+ ''
                }
                console.log(this.ruleForm)

            }else{
                // if(this.groupName == 'CAB组'){
                //     console.log('CAB组')
                //     console.log(this.parentId)
                //     this.ruleForm.parentId = ['99998_group']
                // }
                this.ruleForm.parentId = ['99998_group']
            }
            this.loading = false
        },

        methods: {
            showSelect(){
                console.log(this.ruleForm.parentId);

            },
            // 确认提交按钮
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let parentId='0_custom_department'
                        if (this.ruleForm.parentId.length===0){
                            parentId='0_custom_department'
                        } else{
                            parentId = Array.isArray(this.ruleForm.parentId) ? this.ruleForm.parentId.pop() : '0_custom_department'

                        }
                        console.log(parentId)
                        let params = {
                            ...this.ruleForm,
                            parentId: parentId.split('_')[0]
                        }
                        if(this.type === 'add') {
                            // params.parentId = parentId.split('_')[0]
                            if(parentId.split('_')[1] === 'group'){
                                this.request({ request: services.groupAdd, params })
                            }else{
                                this.request({ request: services.departmentAdd, params })
                            }
                        } else if (this.type === 'edit') {
                            params = {
                                groupId: params.id,
                                name: params.name,
                                description: params.description,
                                parentId: params.parentId
                            }
                            this.request({ request: services.groupUpdate, params })

                        }
                    } else {
                        return false;
                    }
                });
            },

            // 重置
            resetForm(formName) {
                this.$refs[formName].resetFields()
            },

            // 发起请求
            request({ request, params }) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                request(params)
                    .then( res => this.$message.success('创建成功'))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close()
                        this.$modal.close()
                        // this.callback()
                        this.$router.push({
                            path:'/redirect',
                            query:{
                                url:'/systemFeishuCabGroup'
                            }
                        })
                    })
            }
        }
    }
</script>

<style>

</style>
